import React from 'react'
import styled from 'styled-components'

const StyledMessage = styled.div`
  font-style: italic;
  color: #f52e2e;
  margin: 5px 0;
`

export const ErrorMessage = ({ errors = [], children, ...props }) => {
  if (errors && errors.length > 0) {
    return (
      <div>
        {errors.map((error = {}, index) => {
          return <ErrorMessage key={index}>{JSON.stringify(error)}</ErrorMessage>
        })}
      </div>
    )
  }

  return <StyledMessage {...props}>{children}</StyledMessage>
}
